module.exports = __webpack_public_path__ + "static/crj-b64934f99636703befe10ca42ec03b28.jpg";